/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/constants/SoftwareDiscoveryConstants.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import enviro from 'enviro';

// Prod short IDs for testing tool discovery cards:
// MARKETING_AUTOMATION: 8633874, MARKETING_LEAD_GEN: 14426920, SALES_PROSPECTING: 1527200

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/constants/SoftwareDiscoveryConstants.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const SD_EXPERIMENT_USE_CASES = {
  MARKETING_LEAD_GEN: 'MARKETING_LEAD_GEN',
  MARKETING_AUTOMATION: 'MARKETING_AUTOMATION',
  SALES_PROSPECTING: 'SALES_PROSPECTING'
};
//OTGs that are allowed to use Learn By Doing: https://docs.google.com/spreadsheets/d/17fkUMy4uMeOwnWqDNuIW1RKFZuP2uigOyBlOTeCvUP4/edit?gid=1614254752#gid=1614254752

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/constants/SoftwareDiscoveryConstants.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const ALLOWED_OTG_IDS = enviro.isProd() ? [1843222, 1846274, 1842560, 1843220, 2639657] : [33660538, 27527805, 39043943];